<template>
  <label
    :for="forId"
    class="block text-[10px] font-bold uppercase tracking-wider mb-1.5 ml-1 transition-colors"
    :class="[textColorClass, extraClass]"
  >
    {{ text }}
  </label>
</template>

<script setup>
defineProps({
  text: { type: String, default: '' },
  forId: { type: String, default: '' },
  textColorClass: { type: String, default: 'text-[#1c4848]/60' },
  extraClass: { type: String, default: '' }
});
</script>
